/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteHolidayCalendarInput = {
    id: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteHolidayCalendarMutationVariables = {
    input: DeleteHolidayCalendarInput;
};
export type deleteHolidayCalendarMutationResponse = {
    readonly deleteHolidayCalendar: {
        readonly deletedHolidayCalendarId: string | null;
    } | null;
};
export type deleteHolidayCalendarMutation = {
    readonly response: deleteHolidayCalendarMutationResponse;
    readonly variables: deleteHolidayCalendarMutationVariables;
};



/*
mutation deleteHolidayCalendarMutation(
  $input: DeleteHolidayCalendarInput!
) {
  deleteHolidayCalendar(input: $input) {
    deletedHolidayCalendarId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteHolidayCalendarInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteHolidayCalendarPayload",
    "kind": "LinkedField",
    "name": "deleteHolidayCalendar",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedHolidayCalendarId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteHolidayCalendarMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteHolidayCalendarMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteHolidayCalendarMutation",
    "operationKind": "mutation",
    "text": "mutation deleteHolidayCalendarMutation(\n  $input: DeleteHolidayCalendarInput!\n) {\n  deleteHolidayCalendar(input: $input) {\n    deletedHolidayCalendarId\n  }\n}\n"
  }
};
})();
(node as any).hash = '93df777568488b5a933ad12cc6daa526';
export default node;
